import { render, staticRenderFns } from "./SensorDecoderAlarmComponent.vue?vue&type=template&id=c671e766"
import script from "./SensorDecoderAlarmComponent.vue?vue&type=script&lang=js"
export * from "./SensorDecoderAlarmComponent.vue?vue&type=script&lang=js"
import style0 from "./SensorDecoderAlarmComponent.vue?vue&type=style&index=0&id=c671e766&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports